import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { MenuItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { ProjectId } from "../admin-panel/enums/project-id.enum";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isTechSupport: boolean = false;
  public usersItems: MenuItem[];
  public paymentsItems: MenuItem[];
  public inPaymentsMenu: boolean = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService
    ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe(() => {
      this.addFunctionToDropdownItems();
    });
  }

  ngOnInit(): void {
    this.authService._isTechSupport$.subscribe((result) => {
      this.isTechSupport = result;
    });
  }

  public addFunctionToDropdownItems(): void {
    this.usersItems = [
      {
        label: this.translate.instant('MEMBERS.APP_USERS'),
        items: []
      }];

    Object.values(ProjectId).filter(t => !isNaN(+t)).forEach(value => {
      this.usersItems[0].items?.push({
        label: this.getLabelForProjectId(value),
        routerLink: 'admin/app-users',
        queryParams: { appId: value }
      })
    });

    this.paymentsItems = [
      {
        label: this.translate.instant('BUSINESS.PAYMENTS'),
        command: () => this.inPaymentsMenu = !this.inPaymentsMenu,
        items: []
      }];

    Object.values(ProjectId).filter(t => !isNaN(+t)).forEach(value => {
      this.paymentsItems[0].items?.push({
        label: this.getLabelForProjectId(value),
        routerLink: 'admin/payments',
        queryParams: { appId: value }
      })
    });
  }

  public getLabelForProjectId(projectId: ProjectId | string): string {
    switch (projectId) {
      case ProjectId.SocialitePOS:
        return 'Socialite POS';
      case ProjectId.SocialiteResy:
        return 'Socialite Resy';
      case ProjectId.SocialiteEvents:
        return 'Socialite Events';
      default:
        return '';
    }
  }
}
